module.exports = __webpack_public_path__ + "img/EmptyImage.5b365e81.jpg";